module.exports = __webpack_public_path__ + "img/m4.9d90a7ad.jpg";